import React, { memo, useMemo, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Theme as theme, GlobalStyle } from 'theming/theme';
import GlobalFonts from 'theming/GlobalFonts';
import { useStateValue, useDispatch } from 'state/contextState';
import notification from 'components/notification';
import useUpdateDatabase from 'hooks/useUpdateDatabase';
import { lf } from 'storage/localForage';
import Header from 'components/header';
import Homepage from 'containers/Homepage';
import About from 'containers/About';
import Settings from 'containers/Settings';
import { ThemeProvider } from 'styled-components';
import {
  SET_INITIAL_SETTINGS,
} from 'reducers/settingsReducer';
import {
  LOADED_SETTINGS,
} from 'reducers/loadingReducer';
import {
  REMOVE_ALL_NOTES,
} from 'reducers/homePageReducer';

const Content = () => (
  <>
    <Header />
    <Routes>
      <Route exact path="/" element={<Homepage />} />
      <Route exact path="/about" element={<About />} />
      <Route exact path="/settings" element={<Settings />} />
    </Routes>
  </>
);

const Routing = () => {
  const dispatch = useDispatch();

  // Theme
  const { settingsLoaded } = useStateValue('loading');
  const { isDarkMode, interval } = useStateValue('settings');
  const { totalTime } = useStateValue('homePage');
  const currentTheme = useMemo(() => theme(isDarkMode), [isDarkMode]);

  const [updated, setUpdated] = useUpdateDatabase();

  // Initial load check
  useEffect(() => {
    const init = async () => {
      const data = await lf.getItem('settings');
      await dispatch({ type: SET_INITIAL_SETTINGS, data });
      await dispatch({ type: LOADED_SETTINGS });
    };
    init();
  }, [dispatch]);

  // Notifications
  useEffect(() => {
    if (Math.round(totalTime) !== 0 && (Math.round(totalTime) / 60) % interval === 0) {
      notification.sendNotification(`${interval} minute(s) passed`);
    }
  }, [totalTime, interval]);

  // Clean database
  if (updated === true) {
    dispatch({ type: REMOVE_ALL_NOTES }); // TODO delete entire database
    setUpdated(false);
  }

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeProvider theme={currentTheme}>
        <>
          <GlobalStyle />
          <GlobalFonts />
          {
            settingsLoaded && (
              <Content />
            )
          }
        </>
      </ThemeProvider>
    </Router>
  );
};

export default memo(Routing);
